import createBreakpoints from '@material-ui/core/styles/createBreakpoints';

export const breakpoints = createBreakpoints({ xxs: 280 });
export const spacing = 8;
